<template>
  <div class="calculator-container szamlanyitas" id="app">
    <div class="container py-5">
      <div class="row slider-row mb-5">
        <h3 class="mb-5 text-center">Havi megtakarítás</h3>
        <div class="col-12 px-5">
          <vue-slider
              v-if="amountValues.length"
              v-model="monthly_save"
              :data="amountValues"
              :adsorb="true"
              :height="10"
              :processStyle="{ backgroundColor: '#BA0000' }"
              :tooltipStyle="{ color: 'white', backgroundColor: 'black' }"
              :railStyle="{ backgroundColor: '#E5E5E5' }"
              :key="'ms-' + monthly_save"
              :marks="false"
              tooltip="always"
              :tooltip-formatter="val => new Intl.NumberFormat('hu-HU').format(val) + ' Ft'"
          >
            <template #dot>
              <div
                  style="width:20px;height:20px;background-color:#ba0000;border-radius:50%;margin-top:-4px;"
              />
            </template>
          </vue-slider>
        </div>
        <div class="d-flex">
          <div class="col-6 label min">
            {{ $filters.formatPrice(slider_min) }} Ft
          </div>
          <div class="col-6 label max text-end">
            {{ $filters.formatPrice(slider_max) }} Ft
          </div>
        </div>
      </div>

      <div class="row slider-row mb-5 spare_time_container">
        <h3 class="mb-5 text-center">Megtakarítási idő</h3>
        <div class="col-12 px-5 mb-5">
          <vue-slider
              v-if="allowedValues.length"
              v-model="spare_time"
              :data="allowedValues"
              :height="10"
              :marks="true"
              :adsorb="true"
              :processStyle="{ backgroundColor: '#BA0000' }"
              :railStyle="{ backgroundColor: '#E5E5E5' }"
              :tooltipStyle="{ color: 'white', backgroundColor: 'black' }"
              :key="'st-'+ monthly_save"
              :tooltip-formatter="formatSpareTimeTooltip"
              tooltip="always"
              class="month-slider"
          >
            <template #dot>
              <div
                  style="width:20px;height:20px;background-color:#ba0000;border-radius:50%;margin-top:-4px;"
              ></div>
            </template>
          </vue-slider>
        </div>
      </div>

      <div class="row mb-5">
        <div class="col-12 px-5">
          <div class="form-check">
            <input
                class="form-check-input"
                type="checkbox"
                id="ingatlanExtraKondicio"
                v-model="ingatlan_extra"
            />
            <label class="form-check-label" for="ingatlanExtraKondicio">
                Fundamenta Ingatlan Extra Kondició - Kedvezöbb kamat, szakszerű ingatlan ügyintézés,
                ha a Fundamenta Ingatlan kinálatából másároltad meg álmaid otthonát. <a href="#">Magyarázat</a>
            </label>
          </div>
        </div>
      </div>

      <div class="row align-items-center bg-gray-20 pt-3 pb-2 mx-4">
        <div class="col-12 col-lg-8 mb-3 mb-lg-0">
          <h3 class="h2 mb-0">
            Szerződéses összeg, amely lakáscélra felhasználható:
          </h3>
          <span>
            Az összeg a Kamatbónusszal növelt megtakarítást és a lakáshitelt is
            magában foglalja.
          </span>
        </div>
        <div class="col-12 col-lg-4 text-center text-lg-end">
          <h3 class="h1 c-red">
            {{ $filters.formatPrice(contractAmountByMonthlySave) }} Ft
          </h3>
        </div>
      </div>
    </div>

    <!-- Részletek gomb -->
    <div class="row">
      <div class="col-12 text-center">
        <button
            ref="detailsBtn"
            class="btn btn-primary min-w-300 mx-auto btn-collapse"
            type="button"
            :aria-expanded="detailsOpen ? 'true' : 'false'"
            :aria-controls="moreId"
            @click="toggleDetails"
        >
          Részletek
        </button>
      </div>
    </div>

    <!-- Összecsukható rész -->
    <div
        :id="moreId"
        ref="more"
        class="mt-2 collapse"
        :class="{ show: detailsOpen }"
    >
      <div class="container py-5 px-5">
        <p class="h2 c-red">Szerződéskötés</p>

        <div class="row">
          <div class="col-12 col-lg-8">
            <p class="label">Havi megtakarítás</p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">
              {{ $filters.formatPrice(monthly_save) }} Ft
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-8">
            <p class="label">Megtakarítási idő:</p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">{{ sparetime_to_show }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-8">
            <p class="label">Számlanyitási díj:</p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">
              {{ $filters.formatPrice(account_open_fee) }} Ft
            </p>
          </div>
        </div>


        <div class="row mb-3">
          <div class="col-12 col-lg-8">
            <p class="label">Havi számlavezetési díj:</p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">
              {{ $filters.formatPrice(account_management_fee) }} Ft
            </p>
          </div>
        </div>

        <p class="h2 c-red">Megtakarítási időszak</p>

        <div class="row">
          <div class="col-12 col-lg-8">
            <p class="label">Összes saját megtakarítás:</p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">
              {{ $filters.formatPrice(all_own_payments) }} Ft
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-8">
            <p class="label">Betéti kamat a megtakarítás után:</p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">
              {{ $filters.formatPrice(deposit_rate) }} Ft
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-8">
            <p class="label">Kamatbónusz:</p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">
              {{ $filters.formatPrice(saving_bonus) }} Ft
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-8">
            <p class="label">Önerő bónusz:</p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">
              {{ $filters.formatPrice(ingatlan_extra ? onero_bonusz : 0) }} Ft
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-8">
            <p class="label">EBKM Kamatbónusszal:</p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">{{ saving_without_bonus }} %</p>
          </div>
        </div>

        <div class="row" v-if="ingatlan_extra">
          <div class="col-12 col-lg-8">
            <p class="label">
              EBKM Kamatbónusszal és akcióval:
            </p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">{{ saving_with_bonus }} %</p>
          </div>
        </div>

        <div class="row align-items-center bg-gray-10 pt-3 pb-1 my-3">
          <div class="col-12 col-lg-8">
            <p class="h3">
              Teljes megtakarítás a megtakarítási idő végén:
            </p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="h2">
              {{ $filters.formatPrice(ingatlan_extra ? onero_bonusz_sajat_megtakaritas : own_savings) }} Ft
            </p>
          </div>
        </div>

        <div class="row align-items-center bg-gray-10 pt-3 pb-1 my-3">
          <div class="col-12 col-lg-8">
            <p class="h3">
              Lejáratkor igényelhető lakáskölcsön összege:
            </p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="h2">
              {{ $filters.formatPrice(ingatlan_extra ? onero_bonusz_lakaskolcson : housing_loan) }} Ft
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-8">
            <p class="label">Törlesztőrészletek száma:</p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">{{ ingatlan_extra ? onero_bonusz_torlesztoreszletek_szama : installment_number }} Hónap</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-8">
            <p class="label">Havi fix törlesztőrészlet:</p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">
              {{ $filters.formatPrice(ingatlan_extra ? onero_bonusz_torlesztoreszlet :installment_amount) }} Ft
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-8">
            <p class="label">THM:</p>
          </div>
          <div class="col-12 col-lg-4 text-left text-lg-end">
            <p class="value">{{ ingatlan_extra ? onero_bonusz_thm :thm }} %</p>
          </div>
        </div>

        <!-- Akció gombok -->
        <div class="row mt-4">
          <div class="col-12 col-lg-4 text-center">
            <button
                class="btn btn-link mx-auto"
                data-bs-toggle="modal"
                data-bs-target="#emailModal"
            >
              <i class="fas fa-paper-plane mr-2"></i>Küldés e-mailben
            </button>
          </div>
          <div class="col-12 col-lg-4 text-center">
            <button
                class="btn btn-link mx-auto"
                @click="printpdf"
                :disabled="isPrinting"
            >
              <i class="fas fa-print mr-2"></i>Nyomtatás
            </button>
          </div>
          <div class="col-12 col-lg-4 text-center">
            <button class="btn btn-link mx-auto" @click="downloadpdf">
              <i class="fas fa-download mr-2"></i>Letöltés
            </button>
          </div>

          <!-- Email modal -->
          <div
              class="modal fade"
              id="emailModal"
              tabindex="-1"
              aria-labelledby="emailModalLabel"
              aria-hidden="true"
              data-bs-backdrop="false"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h1 class="modal-title fs-5" id="emailModalLabel">
                    Küldés emailben
                  </h1>
                  <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body">
                  <form
                      @submit.prevent="onEmail"
                      ref="form"
                      v-if="!mail_sent"
                  >
                    <div class="mb-3">
                      <label
                          for="email-input"
                          class="form-label"
                      >Email</label>
                      <input
                          type="email"
                          class="form-control"
                          id="email-input"
                          v-model="email"
                          required
                          aria-describedby="emailHelp"
                      />
                      <div class="form-text fs-6">
                        Add meg az e-mail címed, ahová a kikalkulált ajánlatot
                        elküldhetjük!
                      </div>
                    </div>
                    <div class="d-flex justify-content-center">
                      <button
                          type="submit"
                          class="btn btn-primary w-75 btn-modal fw-bold"
                      >
                        <i class="fas fa-paper-plane me-2"></i>
                        Kérem e-mailben
                      </button>
                    </div>
                  </form>
                  <p
                      v-else
                      class="text-center mb-0"
                  >
                    Köszönjük érdeklődésed!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- /Email modal -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueSlider from "vue-3-slider-component";
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Collapse } from "bootstrap";

export default {
  components: { VueSlider },

  data() {
    return {
      json: {},
      monthly_save: null,
      ingatlan_extra: false,
      spare_time: null,
      slider_min: 0,
      slider_max: 0,
      amountValues: [],
      allowedValues: [],
      sparetime_to_show: null,
      contract_amount: null,
      own_savings: null,
      all_own_payments: null,
      deposit_rate: null,
      saving_without_bonus: null,
      saving_with_bonus: null,
      saving_bonus: null,
      housing_loan: null,
      thm: null,
      onero_bonusz: null,
        onero_bonusz_sajat_megtakaritas: null,
        onero_bonusz_lakaskolcson: null,
        onero_bonusz_torlesztoreszletek_szama: null,
        onero_bonusz_torlesztoreszlet: null,
        onero_bonusz_thm: null,

      installment_amount: null,
      installment_number: null,
      account_open_fee: null,
      extra_kamatbonusz: null,
      account_management_fee: 234,
      email: null,
      mail_sent: false,

      detailsOpen: false,
      _collapse: null,
      _onShown: null,
      _onHidden: null,

      isPrinting: false,
    };
  },

  mounted() {
    axios
        .get(`${import.meta.env.VITE_API_URL}/api/getjson/lakastakarek-ingatlan-extra`)
        .then((response) => {
          this.json = response.data || {};
          this.initFromJson();
        });

    this.$nextTick(() => {
      const el = this.$refs.more;
      if (!el) return;

      this._collapse = new Collapse(el, { toggle: false });

      this._onShown = () => {
        this.detailsOpen = true;
        this.$refs.detailsBtn?.setAttribute("aria-expanded", "true");
      };
      this._onHidden = () => {
        this.detailsOpen = false;
        this.$refs.detailsBtn?.setAttribute("aria-expanded", "false");
      };

      el.addEventListener("shown.bs.collapse", this._onShown);
      el.addEventListener("hidden.bs.collapse", this._onHidden);
    });

    document.addEventListener("hidden.bs.modal", () => {
      document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.remove());
      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("paddingRight");
    });
  },

  beforeUnmount() {
    const el = this.$refs.more;
    if (el) {
      if (this._onShown)
        el.removeEventListener("shown.bs.collapse", this._onShown);
      if (this._onHidden)
        el.removeEventListener("hidden.bs.collapse", this._onHidden);
    }

    try {
      this._collapse?.dispose?.();
    } catch {}
    this._collapse = null;
  },

  watch: {

    monthly_save(val) {
      if (val != null) this.monthly_save = Number(val);
      this.refreshSpareTimes();
    },
    spare_time(val) {
      if (val != null) this.spare_time = Number(val);
      this.sparetime_to_show =
          this.spare_time != null
              ? `${this.spare_time} hónap (${this.$filters.monthesAndYears(
                  this.spare_time
              )})`
              : null;
    },
  },

  computed: {
    contractAmountByMonthlySave() {
      if (!this.json || this.monthly_save == null || this.spare_time == null) {
        return null;
      }

      const obj =
          this.json?.[String(this.monthly_save)]?.[
              String(this.spare_time)
              ];

      if (!obj) return null;

      this.own_savings = obj.own_savings;
      this.all_own_payments = obj.all_own_payments;
      this.deposit_rate = obj.deposit_rate;
      this.saving_without_bonus = obj.saving_without_bonus;
      this.saving_bonus = obj.saving_bonus;
      this.saving_with_bonus = obj.saving_with_bonus;
      this.housing_loan = obj.housing_loan;
      this.thm = obj.thm;
      this.onero_bonusz = obj.onero_bonusz;
      this.onero_bonusz_sajat_megtakaritas = obj.onero_bonusz_sajat_megtakaritas;
        this.onero_bonusz_lakaskolcson = obj.onero_bonusz_lakaskolcson;
        this.onero_bonusz_torlesztoreszletek_szama = obj.onero_bonusz_torlesztoreszletek_szama
        this.onero_bonusz_torlesztoreszlet = obj.onero_bonusz_torlesztoreszlet
        this.onero_bonusz_thm = obj.onero_bonusz_thm
      this.installment_amount = obj.installment_amount;
      this.extra_kamatbonusz = obj.extra_kamatbonusz;
      this.installment_number = obj.installment_number;
      this.account_open_fee = Math.floor(obj.contract_amount * 0.01);

      return obj.contract_amount;
    }
  },

  methods: {
    apiBase() {
      const base = (import.meta?.env?.VITE_API_URL || "").trim();
      return base.replace(/\/+$/, "");
    },

    toggleDetails() {
      if (!this._collapse) return;
      this._collapse.toggle();
    },

    initFromJson() {
      const modeData = this.json || {};
      const amounts = Object.keys(modeData)
          .map(Number)
          .filter((n) => !Number.isNaN(n))
          .sort((a, b) => a - b);

      if (!amounts.length) {
        this.amountValues = [];
        this.slider_min = 0;
        this.slider_max = 0;
        this.monthly_save = null;
        this.allowedValues = [];
        this.spare_time = null;
        this.sparetime_to_show = null;
        return;
      }

      this.amountValues = amounts;
      this.slider_min = amounts[0];
      this.slider_max = amounts[amounts.length - 1];

      if (!amounts.includes(Number(this.monthly_save))) {
        this.monthly_save = this.slider_min;
      }

      this.refreshSpareTimes();
    },

    refreshSpareTimes() {
      const spareMap =
          this.json?.[String(this.monthly_save)] || {};
      const spare = Object.keys(spareMap)
          .map(Number)
          .filter((n) => !Number.isNaN(n))
          .sort((a, b) => a - b);

      if (!spare.length) {
        this.allowedValues = [];
        this.spare_time = null;
        this.sparetime_to_show = null;
        return;
      }

      this.allowedValues = spare;

      if (!spare.includes(Number(this.spare_time))) {
        this.spare_time = spare[0];
      }

      this.sparetime_to_show = `${this.spare_time} hónap (${this.$filters.monthesAndYears(
          this.spare_time
      )})`;
    },

    downloadpdf() {
      if (this.monthly_save == null || this.spare_time == null) {
        return;
      }

      const base = this.apiBase();
      const url =
          `${base}/api/getPdf?calculator=lakastakarek-ingatlan-extra` +
          `&monthly_save=${encodeURIComponent(this.monthly_save)}` +
          `&monthly_inpayment_number=${encodeURIComponent(this.spare_time)}` +
      `&ingatlan_extra=${this.ingatlan_extra ? 1 : 0}`;

      const a = document.createElement("a");
      a.href = url;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },

    formatSpareTimeTooltip(value) {
      const v = Number(value) || 0;
      const years = Math.floor(v / 12);
      const months = v % 12;
      const parts = [];
      if (years > 0) parts.push(`${years} év`);
      if (months > 0) parts.push(`${months} hónap`);
      const ym = parts.length ? parts.join(" ") : "0 hónap";
      return `${v} hónap (${ym})`;
    },

    async printpdf() {
      if (this.isPrinting) return;
      if (this.monthly_save == null || this.spare_time == null) return;

      this.isPrinting = true;

      const base = this.apiBase();
      const url =
          `${base}/api/getPdf?calculator=lakastakarek-ingatlan-extra` +
          `&monthly_save=${encodeURIComponent(this.monthly_save)}` +
          `&monthly_inpayment_number=${encodeURIComponent(this.spare_time)}` +
              `&ingatlan_extra=${this.ingatlan_extra ? 1 : 0}`;

      try {
        const res = await fetch(url, { credentials: "include" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const blob = await res.blob();
        const ct = (res.headers.get("Content-Type") || "").toLowerCase();
        if (!ct.includes("pdf")) throw new Error("Nem PDF érkezett (Content-Type).");

        const objectUrl = URL.createObjectURL(blob);

        const old = document.getElementById("printdocument");
        if (old) {
          try {
            old.remove();
          } catch {}
        }

        const iframe = document.createElement("iframe");
        iframe.id = "printdocument";
        iframe.style.position = "fixed";
        iframe.style.width = "1px";
        iframe.style.height = "1px";
        iframe.style.opacity = "0";
        iframe.style.border = "0";
        iframe.style.pointerEvents = "none";

        let printed = false;

        const cleanup = () => {
          try {
            URL.revokeObjectURL(objectUrl);
          } catch {}
          try {
            iframe.remove();
          } catch {}
          this.isPrinting = false;
        };

        const doPrint = () => {
          if (printed) return;
          const win = iframe.contentWindow;
          if (win && typeof win.print === "function") {
            printed = true;
            setTimeout(() => {
              try {
                win.focus();
                win.print();
              } catch {}
              setTimeout(cleanup, 2000);
            }, 150);
          }
        };

        iframe.addEventListener("load", doPrint);

        const poll = setInterval(doPrint, 300);
        setTimeout(() => {
          clearInterval(poll);
          if (!printed) setTimeout(cleanup, 2000);
        }, 7000);

        document.body.appendChild(iframe);
        iframe.src = objectUrl;
      } catch (e) {
        console.error("printpdf hiba:", e);
        this.isPrinting = false;
      }
    },

    onEmail() {
      axios
          .post(`${this.apiBase()}/api/sendInEmail`, {
            email: this.email,
            monthly_save: this.monthly_save,
            monthly_inpayment_number: this.spare_time,
            calculator: "lakastakarek-ingatlan-extra",
              ingatlan_extra:this.ingatlan_extra ? 1 : 0
          })
          .then(() => {
            this.mail_sent = true;
            setTimeout(() => {
              const modalEl = document.getElementById("emailModal");
              if (modalEl && window.bootstrap?.Modal) {
                const inst = window.bootstrap.Modal.getOrCreateInstance(
                    modalEl,
                    { backdrop: false }
                );
                inst.hide();
              }
              this.mail_sent = false;
            }, 2000);
          });
    },
  },

  filters: {
    formatPrice(value) {
      const n =
          Number(String(value ?? "").replace(/[^\d]/g, "")) || 0;
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    monthesAndYears(totalMonths) {
      const m = Number(totalMonths) || 0;
      const y = Math.floor(m / 12);
      const r = m % 12;
      const parts = [];
      if (y > 0) parts.push(`${y} év`);
      if (r > 0) parts.push(`${r} hónap`);
      return parts.length ? parts.join(" ") : "0 hónap";
    },
  },
};
</script>

<style scoped>
.price-slider,
.month-slider {
  width: 100%;
  display: block;
}
.vue-slider {
  width: 100%;
}
.vue-slider-rail {
  height: 10px !important;
}
.bg-gray-20 {
  background: #f2f2f2;
}
.bg-gray-10 {
  background: #f7f7f7;
}
.c-red {
  color: #ba0000;
}
.label {
  margin-bottom: 0.25rem;
}
.value {
  font-weight: 600;
}
.min-w-300 {
  min-width: 300px;
}
</style>
